import React from 'react';
import Navbar from '../components/layout/Navbar';
import UpdateContactForm from '../components/layout/UpdateContactForm';
import { useParams } from 'react-router-dom';

function UpdateContactPage() {
  let { selectName } = useParams();

  return (
    <div>
      <Navbar />
      <div className='container'>
        <br />
        <h2>Update Contact</h2>
        <h4>This will overwrite existing information for this contact</h4>
        <UpdateContactForm updateName={selectName} />
      </div>
    </div>
  );
}

export default UpdateContactPage;
